import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Persist } from "formik-persist";
import sanityClient from "../client";
import Nav from "../components/Nav";
import { Navigate } from "react-router-dom";

const USE_INITIAL_FORM_VALUES = false;

class ReviewForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formError: null,
      isCaseContractApproved: false,
      isAgreementLCSWApproved: false,
      isFeedbackStatementApproved: false,
      showingForm: true,
      showingCaseContract: false,
      showingLCSWAgreement: false,
      showingFeedbackStatement: false,
      loading: false,
      shouldRedirect: false,
    };

    if (USE_INITIAL_FORM_VALUES) {
      this.initialValues = {
        originalStatement:
          "By submitting this case review, I agree that Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut ...",
        submissionDate: new Date(),
        clientName: "Matt McGivney",
        clientEmail: "myemail@example.com",
        clientPhone: "123-123-4567",
        petName: "Luna",
        petAge: 0,
        petBreed: "Golden retriever",
        petWeight: 0,
        euthanasiaReason: "Pet was suffering from ...",
        euthanasiaDate: "2021-12-31",
        circumstancesOfConcern:
          "During the euthanasia, we were concerned with...",
        actionsThusFar: "Thus far, we have...",
        goals: "Our goals with the case review are to...",
      };
    } else {
      this.initialValues = {
        originalStatement:
          "By submitting this case review, I agree that Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut ...",
        submissionDate: new Date(),
        clientName: "",
        clientEmail: "",
        clientPhone: "",
        petName: "",
        petAge: "",
        petBreed: "",
        petWeight: "",
        euthanasiaReason: "",
        euthanasiaDate: "",
        circumstancesOfConcern: "",
        actionsThusFar: "",
        goals: "",
      };
    }
  }

  RESET_FORM_ON_SUBMISSION = false;

  isARequiredField = "This is a required field";

  validationSchema = Yup.object({
    originalStatement: Yup.string().required(),
    submissionDate: Yup.date().default(() => new Date()),
    clientName: Yup.string().required(this.isARequiredField),
    clientEmail: Yup.string().email().required(this.isARequiredField),
    clientPhone: Yup.string().required(this.isARequiredField),
    petName: Yup.string().required(this.isARequiredField),
    petAge: Yup.string().required(this.isARequiredField),
    petBreed: Yup.string().required(this.isARequiredField),
    petWeight: Yup.string().required(this.isARequiredField),
    euthanasiaReason: Yup.string().required(this.isARequiredField),
    euthanasiaDate: Yup.string().required(this.isARequiredField),
    circumstancesOfConcern: Yup.string().required(this.isARequiredField),
    actionsThusFar: Yup.string().required(this.isARequiredField),
    goals: Yup.string().required(this.isARequiredField),
  });

  onSubmit = (values) => {
    this.setState({ formError: null, loading: true });

    // set values original statement
    if (values && values.originalStatement) {
      values.originalStatement = this.state.originalStatement;
    } else {
      return;
    }

    console.log("On submit");
    console.log(values);

    const request = { ...values, _type: "review", _id: "drafts." };

    let reviewId = "";

    sanityClient.create(request).then((result) => {
      this.setState({ loading: false });
      console.log("result");
      console.log(result);

      localStorage.setItem("reviewId", result._id);

      this.setState({ shouldRedirect: true });
    });
  };

  componentDidMount() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // dev code
      console.log("Development mode");
    } else {
      // production code
      console.log("Production mode");
    }

    // get the search params from the URL
    const searchParam1 = new URLSearchParams(window.location.search).get(
      "searchParam1"
    );

    if (searchParam1) {
      console.log("Search param 1: " + searchParam1);
      console.log("Setting local storage...");
      localStorage.setItem("searchParam1", searchParam1);
    } else {
      localStorage.removeItem('searchParam1');
    }

    // set the original statement and form title from the intakeFormSettings in Sanity
    const query = `*[_type == "intakeFormSettings"]`;
    const params = {};

    sanityClient.fetch(query, params).then((intakeFormSettings) => {
      console.log("intakeFormSettings:");
      intakeFormSettings.forEach((settings) => {
        console.log(`${settings._id} (${settings.originalStatement})`);
        this.setState({ originalStatement: settings.originalStatement });
        this.setState({ formTitle: settings.title });
      });
    });
  }

  renderError = (message) => (
    <article className="message is-danger">
      <div className="message-body">{message}</div>
    </article>
  );

  renderMessage = (message) => (
    <article className="message mt-5">
      <div className="message-body">{message}</div>
    </article>
  );

  render() {
    return (
      <div className="mt-4">
        {this.state.showingForm && (
          <Formik
            initialValues={this.initialValues}
            validationSchema={this.validationSchema}
            onSubmit={async (values, { resetForm }) => {
              await this.onSubmit(values);
              if (this.RESET_FORM_ON_SUBMISSION) {
                resetForm();
              }
            }}
          >
            <Form>
              <div className="container">
                <p className="title is-4">{this.state.formTitle}</p>
                <p className="subtitle is-4">Case Overview</p>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label" htmlFor="name">
                      Original statement
                    </label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          as="textarea"
                          rows={4}
                          className="textarea"
                          name="originalStatement"
                          type="text"
                          value={this.state.originalStatement}
                          disabled
                        />
                        <ErrorMessage name="name" render={this.renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label" htmlFor="clientName">
                      Contact info
                    </label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          name="clientName"
                          type="text"
                          className="input"
                          placeholder="First and last name"
                        />
                        <ErrorMessage
                          name="clientName"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <div className="control">
                        <Field
                          name="clientEmail"
                          type="text"
                          className="input"
                          placeholder="Email address"
                        />
                        <ErrorMessage
                          name="clientEmail"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label" htmlFor="clientName"></label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          name="clientPhone"
                          type="text"
                          className="input"
                          placeholder="Phone number"
                        />
                        <ErrorMessage
                          name="clientPhone"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Pet's info</label>
                  </div>
                  <div className="field-body">
                    <div className="field control">
                      <Field
                        name="petName"
                        type="text"
                        className="input"
                        placeholder="Pet's name"
                      />
                      <ErrorMessage name="petName" render={this.renderError} />
                    </div>
                    <div className="field">
                      <div className="control">
                        <Field
                          name="petAge"
                          type="text"
                          className="input"
                          placeholder="Pet's age"
                        />
                        <ErrorMessage name="petAge" render={this.renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal"></div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          name="petBreed"
                          type="text"
                          className="input"
                          placeholder="Pet's breed"
                        />
                        <ErrorMessage
                          name="petBreed"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <div className="control">
                        <Field
                          name="petWeight"
                          type="text"
                          className="input"
                          placeholder="Pet's weight"
                        />
                        <ErrorMessage
                          name="petWeight"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Euthanasia info</label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          name="euthanasiaDate"
                          type="text"
                          className="input"
                          placeholder="Euthanasia date"
                        />
                        <ErrorMessage
                          name="euthanasiaDate"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal"></div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          as="textarea"
                          rows={4}
                          name="euthanasiaReason"
                          type="text"
                          className="textarea"
                          placeholder="Reason for euthanasia such as age related changes, heart disease, organ failure, or trauma"
                        />
                        <ErrorMessage
                          name="euthanasiaReason"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Circumstances of concern regarding the euthanasia appointment</label>
                  </div>
                  <div className="field-body">
                    {" "}
                    <div className="field">
                      <div className="control">
                        <Field
                          name="circumstancesOfConcern"
                          as="textarea"
                          rows={4}
                          className="textarea"
                          type="text"
                          placeholder="Circumstances of concern regarding the euthanasia appointment"
                          maxlength="3000"
                        />
                        <ErrorMessage
                          name="circumstancesOfConcern"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Actions taken thus far</label>
                  </div>
                  <div className="field-body">
                    {" "}
                    <div className="field">
                      <div className="control">
                        <Field
                          as="textarea"
                          rows={4}
                          className="textarea"
                          name="actionsThusFar"
                          type="text"
                          placeholder="Actions you have taken thus far regarding this case"
                        />
                        <ErrorMessage
                          name="actionsThusFar"
                          render={this.renderError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Case goals</label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <Field
                          name="goals"
                          as="textarea"
                          rows={4}
                          className="textarea"
                          type="text"
                          placeholder="Your goals for this case review"
                        />
                        <ErrorMessage name="goals" render={this.renderError} />
                      </div>
                    </div>
                  </div>
                </div>
                <article className="message is-warning">
                  <div className="message-body">
                    You won't be able to edit this information. Please
                    double-check your responses before you click "Next".
                  </div>
                </article>
                <div className="is-block">
                  <button
                    type="submit"
                    className={
                      this.state.loading
                        ? "button is-primary is-loading is-pulled-right is-block mb-4"
                        : "button is-primary is-pulled-right is-block mb-4"
                    }
                  >
                    Next
                  </button>
                </div>
                <div className="is-block mt-6">
                  <Nav isCaseOverview="is-underlined has-text-weight-bold"></Nav>
                </div>
              </div>
            </Form>
          </Formik>
        )}
        {this.state.shouldRedirect && (
          <Navigate replace to="/medical-records-upload" />
        )}
      </div>
    );
  }
}

export default ReviewForm;
